import { oneOf, shape, string } from 'prop-types'
import { CurrentUserStates } from '../../models/current-user/current-user-states-enum'
import { idPropType } from '../common/id-prop-type'

export const linkedUserPropType = shape({
    accountId: idPropType,
    displayName: string,
    state: oneOf(Object.values(CurrentUserStates)),
    userId: idPropType
})
